import { IParamsApi } from '@/types/api/params.api';
import { IResponseApi } from '@/types/api/response.api';
import { createApi } from '@reduxjs/toolkit/query/react';
import customBaseAdminQuery from './fetchBaseAdmin';

export const apiAdminCaller = createApi({
  reducerPath: 'apiAdminCaller',
  refetchOnMountOrArgChange: 30,
  baseQuery: customBaseAdminQuery(),
  // get data settings
  endpoints: (builder) => ({
    fetchProfile: builder.query<IResponseApi.IGetUserProfile, void>({
      query: () => {
        return {
          url: 'user/profile',
          method: 'GET',
        };
      },
    }),
    getHolidayBanner: builder.query<IResponseApi.GetHolidayBannerResponse, IParamsApi.GetHolidayBannerParams>({
      query: (input) => {
        return {
          url: 'banner/active',
          method: 'GET',
          params: {
            ...input,
            appKey: 'blockify_fraud',
            platform: 'shopline',
          },
        };
      },
    }),
  }),
});
